const { getElement } = window.BAO.Utils

class FacetSummary extends window.BAO.CustomElement({
  SuperClass: HTMLDetailsElement,
}) {
  connectedCallback () {
    this.setupEventListeners()
  }

  setupEventListeners () {
    this.addEventListener('click', this.onSummaryClick)

    if (this.els.close) {
      this.els.close.element.addEventListener(
        'click',
        this.onCloseClick.bind(this),
      )
    }
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  onSummaryClick (e) {
    const summaryEl = e.target.closest(this.els?.summary.selector)
    const closeEl = e.target.closest(this.els?.close?.selector)

    if (summaryEl || closeEl) {
      if (summaryEl) {
        /* this util is required to ensure the arrow spins back before the element has fully closed */
        summaryEl.classList.toggle('util-NotActive', this.open)

        if (summaryEl && this.hasAttribute('data-filter-facet-level')) {
          if (
            this.getAttribute('data-filter-facet-level') !==
            summaryEl.getAttribute('data-filter-facet-level')
          ) {
            return
          }
        }
      }

      e.preventDefault()

      if (this.isClosing || !this.open) {
        this.start()
      } else if (this.isExpanding || this.open) {
        this.close()
      }
    }
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  onCloseClick (e) {
    e.preventDefault()
    e.stopPropagation()

    this.close()
  }

  start () {
    this.open = true

    this.setAttribute('data-fully-open', 'false')
    window.requestAnimationFrame(() => this.expand())
  }

  close () {
    this.setAttribute('data-fully-open', 'false')
    this.shrink()
  }

  shrink () {
    this.isClosing = true

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.content.animate(
      this.animationConfiguration.in.keyframes,
      this.animationConfiguration.in.options,
    )

    this.animation.onfinish = () => this.onAnimationFinish(false)
    this.animation.oncancel = () => (this.isClosing = false)
  }

  expand () {
    this.isExpanding = true

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.content.animate(
      this.animationConfiguration.out.keyframes,
      this.animationConfiguration.out.options,
    )

    this.animation.onfinish = () => this.onAnimationFinish(true)
    this.animation.oncancel = () => (this.isExpanding = false)
  }

  /**
   * @param {Boolean} open
   *
   * @returns {void}
   */
  onAnimationFinish (open) {
    this.open = open
    this.animation = null

    this.isClosing = false
    this.isExpanding = false
    this.setAttribute('data-fully-open', String(open))
    getElement(this.els.summary.selector, { context: this })?.setAttribute(
      'aria-expanded',
      String(open),
    )
  }

  get content () {
    return window.BAO.Utils.getElement(this.els.content.selector, {
      context: this,
    })
  }

  get animationConfiguration () {
    if (this.hasAttribute('data-animate-from-right')) {
      return {
        in: {
          keyframes: {
            transform: ['translateX(0%)', 'translateX(100%)'],
          },
          options: { duration: 300, easing: 'ease' },
        },
        out: {
          keyframes: {
            transform: ['translateX(100%)', 'translateX(0%)'],
          },
          options: { duration: 300, easing: 'ease' },
        },
      }
    }

    if (this.hasAttribute('data-animate-from-bottom')) {
      return {
        in: {
          keyframes: {
            transform: ['translateY(0%)', 'translateY(100%)'],
          },
          options: { duration: 300, easing: 'ease' },
        },
        out: {
          keyframes: {
            transform: ['translateY(100%)', 'translateY(0%)'],
          },
          options: { duration: 300, easing: 'ease' },
        },
      }
    }

    return {
      in: {
        keyframes: {
          opacity: [1, 0],
          maxHeight: ['550px', '0px'],
        },
        options: { duration: 400, easing: 'ease' },
      },
      out: {
        keyframes: {
          opacity: [0, 1],
          maxHeight: ['0px', '550px'],
        },
        options: { duration: 400, easing: 'ease' },
      },
    }
  }
}

window.customElements.define('facet-summary', FacetSummary, {
  extends: 'details',
})
